import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

import Login from '@/view/login'
import adv from '@/view/adv_code'
import register from '@/view/register.vue'
import retrieve from '@/view/retrieve.vue'
import retrieve2 from '@/view/retrieve2.vue'
import backPwd from '@/view/back-Pwd.vue'
import newsDetail from '@/view/app/news-detail'
import webGuide from '@/view/app/web-guide'
import onlineMappingApp from '@/view/app/online-mapping'
import vipPay from '@/view/app/vip-pay'
import service from '@/view/app/service'
import privacy from '@/view/app/privacy'
import appService from '@/view/app/appservive'
import qqservice from '@/view/app/qqservice'

import Home from '@/view/home'
import askQuestion from '@/view/ask-question'
import expertRecruit from '@/view/expert-recruit'
import newsList from '@/view/news-list'
import newsInfo from '@/view/news-info'
import safeManager from '@/view/safe-manager'
import onlineTraining from '@/view/online-training'
import onlineMapping from '@/view/online-mapping'
import zxTong from '@/view/zx-tong'
import enterpriseList from '@/view/enterprise-list'
import enterpriseListSearch from '@/view/enterprise-list-search'
import productTesting from '@/view/product-testing'
import onlineMappingEdit from '@/view/online-mapping-edit'
import payBank from '@/components/pay-bank'
import evaluateGuide from '@/view/evaluate-guide'
import evaluateCompany from '@/view/evaluate-company'
import evaluateCategory from '@/view/evaluate-category'
import fxcpChangsuo from '@/view/fxcp_changsuo'
import fxcpAnquan from '@/view/fxcp_anquan'
import fxcpResult from '@/view/fxcp_result'
import evaluateCategory2 from '@/view/evaluate-category2'
import evaluateQuestion from '@/view/evaluate-question'
import evaluateQuestionRisk from '@/view/evaluate-question-risk'
import evaluateResult from '@/view/evaluate-result'
import evaluatorInfo from '@/view/evaluator-info'
import purchasing from '@/view/purchasing'
import adress from '@/view/modify-adress.vue'
import modifyInformation from '@/view/modify_information.vue'
import vueTest from '@/view/vue-test.vue'
import cCard from '@/view/c-card'
import fiveG from '@/view/fiveG.vue'
import qrpage from '@/view/Qrcode.vue'

import emergencySupport from '@/view/emergency-support'
import emergencyPlanInfo1 from '@/view/emergency-plan-info1'
import emergencyPlanInfo2 from '@/view/emergency-plan-info2'
import emergencyPlanDetail from '@/view/emergency-plan-detail'
import companyPerson from '@/view/company-person'
import companyAuth from '@/view/company-auth'
import orderdetail from '@/view/orderdetail'
import orderpaydetail from '@/view/orderpaydetail'
import orderlist from '@/view/orderlist'
import authOnline from '@/view/company-auth-in-phone'
import checkpdf from '@/view/contractOnLine'
import about from '@/view/about/aboutUs'
import help from '@/view/helpCenter/helpCenter'
import helpDetail from '@/view/helpCenter/helpDetail'

import cloud from '@/view/cloud/index'
import cloudplan from '@/view/cloud/plan'
// 商城
import shopHome from '@/view/shopping/homePage'
import shoplogin from '@/view/shopping/login'
import goodslist from '@/view/shopping/goods/index'
import goodsdetail from '@/view/shopping/goods/goods-detail'
import shoppingCart from '@/view/shopping/shoppingCart/index'
import checkOrder from '@/view/shopping/shoppingCart/checkOrder'
import remittance from '@/view/shopping/shoppingCart/remittance'
import PersonHomePage from '@/view/shopping/personCenter/personHomePage'
import AddressCenter from '@/view/shopping/personCenter/addressCenter'
import EditAddress from '@/view/shopping/personCenter/editAddress'
import BillCenter from '@/view/shopping/personCenter/billCenter'
import OrderListCenter from '@/view/shopping/personCenter/orderListCenter'
import OrderListDetail from '@/view/shopping/personCenter/orderListDetail'
import invoiceDetail from '@/view/shopping/personCenter/invoiceDetail'
import microFireHouse from '@/view/microFireHouse/index'
import standardDetail from '@/view/microFireHouse/standardDetail'
// 采购
import offerList from '@/view/procurement/offerList'
import offerDetail from '@/view/procurement/offerDetail'
import willOffer from '@/view/procurement/willOffer.vue'
import buyList from '@/view/procurement/buyList'
import informList from '@/view/procurement/informList'
import informDetail from '@/view/procurement/informDetail'

// 缦缦
import myHome from '@/view/manman/homePage'
import guidList from '@/view/manman/guidList'
import myGoods from '@/view/manman/goodsdetail'
import myArea from '@/view/manman/goodsArea'
import goodsMy from '@/view/manman/goodsMy'
import serveMy from '@/view/manman/serveMy'

// H5业务介绍页
import inHome from '@/view/introduce/homePage'
import inHomeDetail from '@/view/introduce/detail'

// App专题页
import appSpecialPage from '@/view/app_specialPage'
import specialTopic from '@/view/app_specialTopic'
import liquorParty from '@/view/liquor/index'

import downPayment from '@/view/activity/downPayment/index'
import shsecuritycheck from '@/view/activity/security'
import redeemCode from '@/view/activity/redeemCode'

//  accompanyBag
import accompanyBagh5 from '@/view/activity/accompanyBag/index-h5'
import accompanyBagpc from '@/view/activity/accompanyBag/index-pc'
//carEmergency
import carEmergencyh5 from '@/view/activity/carEmergency/index-h5'
import carEmergencypc from '@/view/activity/carEmergency/index-pc'
//homeEmergency
import homeEmergencyh5 from '@/view/activity/homeEmergency/index-h5'
import homeEmergencypc from '@/view/activity/homeEmergency/index-pc'




Vue.use(Router)

// export default new Router({
const router = new Router({
  mode: 'history',
  routes: [{
    path: '/', // 跟路由
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: '登录',
    component: Login
    // ,
    // beforeEnter: (to, from, next) => {
    //   console.log(to)
    //   console.log(from)
    //   console.log(next)
    // }
  },
  {
    path: '/adv',
    name: '广告',
    component: adv
    },
  
   

    // 采购
  {
    path: '/offerList',
    name: '采购列表',
    component: offerList
  },
  {
    path: '/offerDetail',
    name: '采购信息',
    component: offerDetail
  },
  {
    path: '/willOffer',
    name: '我要报价',
    component: willOffer
  },
  {
    path: '/web-guide',
    name: 'app推广页',
    component: webGuide
  },
  {
    path: '#/service',
    name: '用户服务协议',
    component: service
  },
  {
    path: '/privacy',
    name: '隐私政策',
    component: privacy
  },
  {
    path: '/onlinemapping',
    name: '在线审图',
    component: onlineMappingApp
  },
  {
    path: '/news-detail',
    name: '新闻详情',
    component: newsDetail
  },
  {
    path: '/vip-pay',
    name: 'vip支付',
    component: vipPay
  },

  {
    path: '/home',
    name: '主页',
    component: Home
  },
  {
    path: '/ask-question',
    name: '我的提问',
    component: askQuestion
  },
  {
    path: '/expert-recruit',
    name: '专家招募',
    component: expertRecruit
  },
  {
    path: '/news-list',
    name: '百科',
    component: newsList
  },
  {
    path: '/news-info',
    name: '详情',
    component: newsInfo
  },
  {
    path: '/safe-manager',
    name: '安全管家',
    component: safeManager
  },
  {
    path: '/online-training',
    name: '在线培训',
    component: onlineTraining
  },
  {
    path: '/enterprise-list',
    name: '企业名录',
    component: enterpriseList
  },
  {
    path: '/enterprise-list-search',
    name: '企业列表',
    component: enterpriseListSearch
  },
  {
    path: '/zx-tong',
    name: '中消通',
    component: zxTong
  },
  {
    path: '/product-testing',
    name: '产品检测',
    component: productTesting
  },
  {
    path: '/online-mapping',
    name: '在线审图',
    component: onlineMapping
  },
  {
    path: '/online-mapping-edit',
    name: '在线审图申请',
    component: onlineMappingEdit
  },
  {
    path: '/pay-bank',
    name: '银行汇款',
    component: payBank
  },
  {
    path: '/eguide',
    name: '风险评测-推广页',
    component: evaluateGuide
  },
  {
    path: '/evaluate-guide',
    name: '风险评测-推广页2',
    component: evaluateGuide
  },
  {
    path: '/evaluate-company',
    name: '风险评测-企业信息',
    component: evaluateCompany,
    meta: {
      allowBack: false
    }
  },
  {
    path: '/risk',
    name: '风险评测企业信息',
    component: evaluateCompany,
    meta: {
      allowBack: false
    }
  },
  {
    path: '/evaluate-category',
    name: '风险评测-分类',
    component: evaluateCategory,
    meta: {
      allowBack: false
    }
  },
  {
    path: '/fxcp_changsuo',
    name: '风险评测-场所答题',
    component: fxcpChangsuo,
    meta: {
      allowBack: false
    }
  },
  {
    path: '/fxcp_anquan',
    name: '风险评测-安全答题',
    component: fxcpAnquan,
    meta: {
      allowBack: false
    }
  },
  {
    path: '/fxcp_result',
    name: '风险评测-评测结果',
    component: fxcpResult,
    meta: {
      allowBack: false
    }
  },
  {
    path: '/evaluate-category2',
    name: '风险评测-分类2',
    component: evaluateCategory2,
    meta: {
      allowBack: false
    }
  },
  {
    path: '/evaluate-question',
    name: '风险评测-答题',
    component: evaluateQuestion,
    meta: {
      allowBack: false
    }
  },
  {
    path: '/evaluate-question-risk',
    name: '风险评测-答题2',
    component: evaluateQuestionRisk
  },
  {
    path: '/evaluate-result',
    name: '风险评测-结果',
    component: evaluateResult
  },
  {
    path: '/evaluator-info',
    name: '风险评测人-信息',
    component: evaluatorInfo
  },
  {
    path: '/purchasing',
    name: '风险评测人-提交订单',
    component: purchasing
  },
  {
    path: '/adress',
    component: adress
  },
  {
    path: '/modify-information',
    component: modifyInformation
  },
  {
    path: '/vue-test',
    name: '测试',
    component: vueTest
  },
  {
    path: '/cid',
    name: '公司名片',
    component: cCard
  },
  {
    path: '/emergency-support',
    name: '应急保障',
    component: emergencySupport
  },
  {
    path: '/emergency-plan1',
    name: '方案咨询1',
    component: emergencyPlanInfo1
  },
  {
    path: '/emergency-plan2',
    name: '方案咨询2',
    component: emergencyPlanInfo2
  },
  {
    path: '/emergency-detail',
    name: '方案咨询详情',
    component: emergencyPlanDetail
  },
  {
    path: '/company-person',
    name: '经办人选择',
    component: companyPerson
  },
  {
    path: '/company-auth',
    name: '企业认证',
    component: companyAuth
  },
  {
    path: '/orderlist',
    name: '方案咨询——订单详情',
    component: orderlist
  },
  {
    path: '/orderdetail',
    name: '方案咨询——订单详情',
    component: orderdetail
  },
  {
    path: '/orderpaydetail',
    name: '方案咨询——订单支付详情',
    component: orderpaydetail
  },
  {
    path: '/register',
    name: '注册',
    component: register
  },
  {
    path: '/retrieve',
    name: '找回密码1',
    component: retrieve
  },
  {
    path: '/retrieve2',
    name: '找回密码22',
    component: retrieve2
  },
  {
    path: '/back-Pwd',
    name: '找回密码2',
    component: backPwd
  },
  {
    path: '/auth-online',
    name: '合同签署',
    component: authOnline
  },
  {
    path: '/checkpdf',
    name: '查看签署',
    component: checkpdf
  },
  {
    path: '/fiveG',
    name: '5G',
    component: fiveG
  },
  {
    path: '/qrpage',
    name: '二维码',
    component: qrpage
  },
  {
    path: '/aboutUs',
    name: '关于我们',
    component: about
  },
  {
    path: '/help',
    name: '帮助中心',
    component: help
  },
  {
    path: '/helpDetail',
    name: '帮助中心详情',
    component: helpDetail
  },
  {
    path: '/cloud',
    name: '消防云介绍',
    component: cloud
  },
  {
    path: '/pcloud',
    name: '消防云合作及方案',
    component: cloudplan
  },

    // ======================================  商城================================
  {
    path: '/shoppingCart',
    name: '购物车',
    component: shoppingCart
  },
  {
    path: '/homePage',
    name: '商城首页',
    component: shopHome,
    children: [{
      path: '/homePage/login',
      name: '商城用户登录',
      component: shoplogin
    },
    {
      path: '/homePage/goodslist',
      name: '商品列表',
      component: goodslist,
      meta: {
        keepAlive: true // 需要缓存
      }
    },
    {
      path: '/homePage/shoppingCart',
      name: '购物车',
      component: shoppingCart
    },
    {
      path: '/homePage/personHomePage',
      name: 'PersonHomePage',
      component: PersonHomePage
    }
    ]
  },
  {
    path: '/checkOrder',
    name: '确认订单',
    component: checkOrder
  },
  {
    path: '/remittance',
    name: '汇款确认',
    component: remittance
  },
  {
    path: '/goodsdetail',
    name: '商品详情',
    component: goodsdetail
  },
  {
    path: '/addressCenter',
    name: 'AddressCenter',
    component: AddressCenter
  },
  {
    path: '/editAddress',
    name: 'editAddress',
    component: EditAddress
  },
  {
    path: '/billCenter',
    name: 'BillCenter',
    component: BillCenter
  },
  {
    path: '/orderListCenter',
    name: 'OrderListCenter',
    component: OrderListCenter
  },
  {
    path: '/orderListDetail',
    name: 'OrderListDetail',
    component: OrderListDetail
  },
  {
    path: '/invoiceDetail',
    name: 'invoiceDetail',
    component: invoiceDetail
  },
  {
    path: '/informList',
    name: 'informList',
    component: informList
  },
  {
    path: '/informDetail',
    name: 'informDetail',
    component: informDetail
  },

  // ============================= 缦缦 ==================================
  {
    path: '/myHome',
    name: 'myHome',
    component: myHome
  },
  {
    path: '/guidList',
    name: 'guidList',
    component: guidList
  },
  {
    path: '/myGoods',
    name: 'myGoods',
    component: myGoods
  },
  {
    path: '/myArea',
    name: 'myArea',
    component: myArea
  },
  {
    path: '/goodsMy',
    name: 'goodsMy',
    component: goodsMy
  },
  {
    path: '/serveMy',
    name: 'serveMy',
    component: serveMy
  },

  // =====================================H5业务介绍页==================
  {
    path: '/inHome',
    name: 'inHome',
    component: inHome,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/inHomeDetail',
    name: 'inHomeDetail',
    component: inHomeDetail
  },
    // ===================================== 微型消防站 =================================
  {
    path: '/microFireHouse',
    name: 'microFireHouse',
    component: microFireHouse,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/standardDetail',
    name: 'standardDetail',
    component: standardDetail
  },
    // =====================================  app专题页暂用 =====================================
  {
    path: '/appSpecialPage',
    name: 'appSpecialPage',
    component: appSpecialPage
  },
  {
    path: '/specialTopic/:name/:id',
    name: 'specialTopic',
    component: specialTopic
  },
  // ==================  酒活动   ===========================liquorParty
  {
    path: '/liquorParty',
    name: 'liquorParty',
    component: liquorParty,
    meta: {
      title: '飞天茅台最低1499'
    }
  },
  // shsecuritycheck
  {
    path: '/activity/downPayment',
    name: 'downPayment',
    component: downPayment,
    meta: {
      title: '兔年限量订金活动'
    }
  },
  {
    path: '/activity/shsecuritycheck',
    name: 'shsecuritycheck',
    component: shsecuritycheck,
    meta: {
      title: '安全检查报告'
    }
    },
    // 活动
    {
      path: '/activity/accompanyBagh5',
      name: 'accompanyBagh5',
      component: accompanyBagh5,
      meta: {
        title: '沁夏随行包'
      }
    },
    {
      path: '/activity/accompanyBagpc',
      name: 'accompanyBagpc',
      component: accompanyBagpc,
      meta: {
        title: '沁夏随行包'
      }
    },
    //carEmergencyh5
     {
      path: '/activity/carEmergencyh5',
      name: 'carEmergencyh5',
      component: carEmergencyh5,
      meta: {
        title: '车紧急救援'
      }
    },
    {
      path: '/activity/carEmergencypc',
      name: 'carEmergencypc',
      component: carEmergencypc,
      meta: {
        title: '车紧急救援'
      }
    },

    //homeEmergency
    {
      path: '/activity/homeEmergencyh5',
      name: 'homeEmergencyh5',
      component: homeEmergencyh5,
      meta: {
        title: '家庭应急'
      }
    },
    {
      path: '/activity/homeEmergencypc',
      name: 'homeEmergencypc',
      component: homeEmergencypc,
      meta: {
        title: '家庭应急'
      }
    },
    {
      path: '/activity/iceElephant',
      name: 'iceElephant',
      component: () => import('@/view/activity/iceElephant/index.vue'),
      meta: {
        title: '冰象灭火宝'
      }

    },



  // redeemCode
  {
    path: '/redeemCode',
    name: 'redeemCode',
    component: redeemCode,
    meta: {
      title: '礼品兑换'
    }
  }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js